/**
 * Three question quiz (sections/lytes-quiz.liquid). Each pick is "name|url|reason".
 * First answers to questions 1 and 2 → pick A; otherwise the second answer to question 3
 * → the dry pick (or B when there is none); anything else → pick B.
 */
class LytesQuiz extends HTMLElement {
  connectedCallback() {
    this.steps = [...this.querySelectorAll('[data-step]')];
    this.result = this.querySelector('[data-result]');
    this.answers = [];
    this.querySelectorAll('[data-answer]').forEach((button) =>
      button.addEventListener('click', () => this.answer(button))
    );
    this.querySelector('[data-restart]')?.addEventListener('click', () => this.restart());
  }

  /** @param {string} key */
  pick(key) {
    const [name = '', url = '', reason = ''] = (this.dataset[key] || '').split('|');
    return { name: name.trim(), url: url.trim(), reason: reason.trim() };
  }

  /** @param {HTMLElement} button */
  answer(button) {
    const step = button.closest('[data-step]');
    const index = this.steps.indexOf(step);
    this.answers[index] = button.dataset.answer;
    step.hidden = true;
    const next = this.steps[index + 1];
    if (next) {
      next.hidden = false;
      next.querySelector('button')?.focus();
    } else {
      this.showResult();
    }
  }

  showResult() {
    const [first, second, third] = this.answers;
    let pick = this.pick('b');
    if (first === 'first' && second === 'first') {
      pick = this.pick('a');
    } else if (third === 'second') {
      const dry = this.pick('dry');
      if (dry.name) pick = { name: dry.name, url: dry.url || pick.url, reason: dry.reason || pick.reason };
    }
    this.result.querySelector('[data-pick-name]').textContent = pick.name;
    this.result.querySelector('[data-pick-reason]').textContent = pick.reason;
    const link = this.result.querySelector('[data-pick-link]');
    link.href = pick.url || '#';
    link.hidden = !pick.url;
    this.result.hidden = false;
  }

  restart() {
    this.answers = [];
    this.result.hidden = true;
    this.steps.forEach((step, i) => (step.hidden = i !== 0));
    this.steps[0]?.querySelector('button')?.focus();
  }
}

if (!customElements.get('lytes-quiz')) customElements.define('lytes-quiz', LytesQuiz);
